var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jp"},[_c('div',{staticClass:"html_content",domProps:{"innerHTML":_vm._s(_vm.pageData.HtmlContent)}}),_c('custom-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }